export enum FileType {
  category = 'category',
  evidence = 'evidence',
  additional_exibition = 'additional_exibition',
  exhibition = 'exhibition',
}
